import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Col, Form, Input, Button, Spin } from 'antd';

const Panel = Collapse.Panel;
const { TextArea } = Input;
const FormItem = Form.Item;

/* eslint-disable */
class TrasversalNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noteModified: false,
      researchModified: false,
    };
  }

  onChangeNotes = (event) => {
    if (event.currentTarget.value !== this.props.registryInfo.annotazioni) {
      this.setState({
        noteModified: true,
      });
    } else {
      this.setState({
        noteModified: false,
      });
    }
  }

  onChangeResearch = (event) => {
    if (event.currentTarget.value !== this.props.registryInfo.attivitaRicerca) {
      this.setState({
        researchModified: true,
      });
    } else {
      this.setState({
        researchModified: false,
      });
    }
  }

  checkModified = () => {
    console.log('verifico se e stato modificato ed e aperto', ((this.state.noteModified 
      || this.state.researchModified)
      && this.props.registryInfo.stato === 'N'));

    return ((this.state.noteModified 
            || this.state.researchModified)
            && this.props.registryInfo.stato === 'N');
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, dataForm) => {
      if (err) {
        return;
      }
      if (this.checkModified) {
        this.props.onUpdateNotes(this.props.registryInfo.idRegistro,
                                 dataForm.annotazioni,
                                 dataForm.attivitaRicerca)
            .then((response) => {
              // TODO: inserire notifiche di antd
              if (response.error) {
                return false;
              }
              return true;
            });
        this.setState({
          noteModified: false,
          researchModified: false,
        });
      }   
    })
  }

  render() {
    console.log('che mi viene passato nelle props: ', this.props);
    const { getFieldDecorator } = this.props.form;
    const annotazioni = this.props.registryInfo.annotazioni;
    const attRicerca = this.props.registryInfo.attivitaRicerca;
    const isDisabled = this.checkModified();
    const isEditable = this.props.registryInfo.stato === 'N';
    return (
      <Collapse className="box box-solid box-unimi vmg10">
        <Panel header="Note di Registro" key="notes">
          <Spin
            spinning={this.props.isEditing}
            tip="Caricamento..."
          >
            <Form
              onSubmit={this.handleSubmit}
              className="simple-form"
            >
              <Col span={12} key="annotazioni">
                <FormItem label={"ANNOTAZIONI"} extra="Max 5000 caratteri">
                  {getFieldDecorator('annotazioni', { initialValue: annotazioni })(
                    <TextArea
                      onChange={this.onChangeNotes}
                      maxLength="5000"
                      readOnly={!isEditable}
                      rows={3}
                    />
                  )}
                </FormItem>
              </Col>
              <Col span={12} key="attRicerca">
                <FormItem label={"ATTIVITÀ DI RICERCA"} extra="Max 20000 caratteri">
                  {getFieldDecorator('attivitaRicerca', { initialValue: attRicerca })(
                    <TextArea
                      onChange={this.onChangeResearch}
                      maxLength="20000"
                      readOnly={!isEditable}
                      rows={3}
                    />
                  )}
                </FormItem>
                <Col span={24} key="button">
                  <FormItem>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={!isDisabled}
                    >
                      Salva
                    </Button>
                  </FormItem>
                </Col>
              </Col>
            </Form>
          </Spin>
        </Panel>
      </Collapse>
    );
  }
}
/* eslint-enable */

TrasversalNotes.propTypes = {
  registryInfo: PropTypes.object.isRequired,
  onUpdateNotes: PropTypes.func.isRequired,
  isEditing: PropTypes.bool,
};

const WrappedTrasversalNotes = Form.create()(TrasversalNotes);

export default WrappedTrasversalNotes;
